import { useEffect } from "react";
import { t, useLanguage } from "../i18n";
export default function useDocumentTitle(title) {
  const {
    language
  } = useLanguage();
  useEffect(() => {
    document.title = title ? `${t(title)} | ${t("BaytBuddy")}` : t("BaytBuddy");
  }, [title, language]);
}
